import { requestGet, requestPut } from "../config/Api";

// Settings públicas del sistema (también vienen en /login y /me).
export const getSettings = () => requestGet("settings");

// payload: { online_queries_enabled: boolean }
export const updateSettings = (payload) => requestPut("settings", payload);
